import { createGlobalStyle, css } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  ${({ theme }) => css`
    *,
    *::before,
    *::after {
      box-sizing: inherit;
    }

    html {
      box-sizing: border-box;
      font-variant-ligatures: none;
      -moz-osx-font-smoothing: grayscale;
      -webkit-font-smoothing: antialiased;
      text-rendering: optimizeLegibility;
      color: ${theme.colors.dark};
    }

    body {
      ${theme.fonts.regular};
      height: 100%;
      margin: 0;
    }

    a,
    button.anchor-link {
      cursor: pointer;
      color: ${theme.colors.primary.default};
      transition: color 0.1s linear;

      &:hover {
        color: ${theme.colors.primary.hover};
      }
      &:focus {
        color: ${theme.colors.primary.hover};
      }
    }

    button.anchor-link {
      background-color: transparent;
      border: 0;
      padding: 0;
      text-decoration: underline;
      ${theme.fonts.regular};
    }

    .hidden {
      display: none;
    }
    strong {
      font-weight: 500;
    }

    .embeddedServiceHelpButton .helpButton .uiButton {
      background-color: #005290;
      font-family: 'Arial', sans-serif;
      min-width: fit-content;
    }
    .embeddedServiceHelpButton .helpButton .uiButton:focus {
      outline: 1px solid #005290;
    }
  `}
`

export default GlobalStyle
